import React from "react";
import { Button } from "../../components/ui/Button";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";

const StepNavigation = ({ currentStep, totalSteps, currentStepComplete, onBack, onNext }) => {
  return (
    <div className="sticky bottom-0 bg-white/95 backdrop-blur-sm border-t border-neutral-200 px-4 py-3 mt-6">
      <div className="flex items-center justify-between">
        {currentStep > 1 ? (
          <Button
            variant="outline"
            onClick={onBack}
            leftIcon={<FiArrowLeft className="w-4 h-4" />}
          >
            Back
          </Button>
        ) : (
          <div />
        )}

        <span className="text-sm text-neutral-500 font-medium">
          Step {currentStep} of {totalSteps}
        </span>

        {currentStep < totalSteps ? (
          <Button
            variant="primary"
            onClick={onNext}
            disabled={!currentStepComplete}
            rightIcon={<FiArrowRight className="w-4 h-4" />}
          >
            Next
          </Button>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
};

export default StepNavigation;
